import { render, staticRenderFns } from "./OrderData.vue?vue&type=template&id=86ca75f4&"
import script from "./OrderData.vue?vue&type=script&lang=ts&"
export * from "./OrderData.vue?vue&type=script&lang=ts&"
import style0 from "./OrderData.vue?vue&type=style&index=0&id=86ca75f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports